import React from 'react';
import PropTypes from 'prop-types';

const ContasForm = (props) => {
    return (
        <div className="row">
            <div className="form-group col">
                <input type="text" placeholder="Conta..." className="form-control"
                    value={props.conta.nome} autoFocus
                    onChange={evt => props.handleChangeNome(evt)} />
            </div>
            <div className="form-group col-2">
                <button type="button" onClick={props.handleChangeVisibilidade}
                    className={`btn btn-block ${props.conta.visivel ? 'btn-success' : 'btn-danger'}`}>
                    &nbsp;
                </button>
            </div>
            <div className="form-group col-2">
                <button type="button" className="btn btn-primary btn-block"
                    onClick={props.handleSave} >
                    <i className="far fa-save" />
                </button>
            </div>
        </div>
    );
};

ContasForm.propTypes = {
    handleSave: PropTypes.func.isRequired,
    handleChangeNome: PropTypes.func.isRequired,
    handleChangeVisibilidade: PropTypes.func.isRequired,
    conta: PropTypes.object.isRequired,
};

export default ContasForm;


// WEBPACK FOOTER //
// ./src/components/contas/ContasForm.js